import template from './jasperReport.html';
import JasperReportCtrl from './jasperReportCtrl';

export default {
  template,
  controller: JasperReportCtrl,
  controllerAs: 'vm',
};
